import {
  Box,
  Grid,
  Modal,
  TableCell,
  TableRow,
  Typography,
  tableCellClasses,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
interface Props {
  item: any;
  handelDeleteItem: (userId: number, userOfficePostId: number) => void;
}
const PermissionTableRows = ({ item, handelDeleteItem }: Props) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  return (
    <>
      <StyledTableRow>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {item.title}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {item.createDatePersian}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {item.creatorUserName}
          </p>
        </StyledTableCell>

        <StyledTableCell align="right" sx={{ borderTop: "none !important" }}>
          <span style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            <Tooltip arrow title="حذف کردن">
              <DeleteOutlineIcon
                // onClick={() => setOpenDeleteModal(true)}
                style={{
                  color: "#1D4A87",
                  cursor: "pointer",
                  marginInline: "3px",
                }}
                // onClick={() => handelDeleteItem(discountId)}
                onClick={() => handelDeleteItem(item.id, item.officePostId)}
              />
            </Tooltip>
          </span>
        </StyledTableCell>
      </StyledTableRow>
      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Box position={"relative"}>
              <Typography
                onClick={() => setOpenDeleteModal(false)}
                component={"p"}
                color={"red"}
                position={"absolute"}
                top={0}
                left={0}
                sx={{ cursor: "pointer" }}
              >
                <CloseIcon></CloseIcon>
              </Typography>
            </Box>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              marginY={"3rem"}
              fontSize={"14px"}
            >
              آیا از <span style={{ color: "#E6123D" }}>حذف کردن </span>
              این
              <span style={{ color: "#E6123D" }}> تخفیف </span> اطمینان دارید؟
            </Typography>
            <Grid container justifyContent={"center"} gap={"1rem"}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#E6123D",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  // onClick={handleDel}
                  onClick={() => {
                    // handelDeleteItem(discountId);
                    setOpenDeleteModal(false);
                  }}
                >
                  حذف کردن کاربر
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#607D8B",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => setOpenDeleteModal(false)}
                >
                  انصراف
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default PermissionTableRows;
